import usePrivateLink from "../../config/usePrivateLink";

import React, { useState, useRef, useEffect, useMemo } from "react";

import Header from "../../master/SideBar";

import Nav from "../../master/NavBar";

import Footer from "../footer";

import { useLocation } from "react-router-dom";

import { viewlist } from "../../../api/BatchService";

import { testList, fetchCard } from "../../../api/TestService";

import { SweetAlertShow, LoadingDiv } from "../../master/Master";

import { getSessions } from "../../../api/SessionsService";

import "./AdmitCard.css";

import { imgBaseUrl } from "../../../api/api";

import moment from "moment";

import TestLayout from "../testsList/TestLayout";

const NOTICE_STORAGE_KEY = "admit_card_notice";

const DESIGN_STORAGE_KEY = "admit_card_design";

const ADMIT_DESIGNS = [
  { value: "modern", label: "Modern (tinted panels)" },
  { value: "classic", label: "Classic (bordered)" },
];

const loadDesign = () => {
  try {
    const saved = localStorage.getItem(DESIGN_STORAGE_KEY);
    if (ADMIT_DESIGNS.some((d) => d.value === saved)) return saved;
  } catch (e) {
    // ignore
  }
  return "modern";
};

const DEFAULT_NOTICE_TITLE = "Instructions to Candidates";

const DEFAULT_NOTICE_TEXT = [
  "Bring this admit card to every examination. Entry is not allowed without it.",

  "Reach the examination hall at least 15 minutes before the start time.",

  "Mobile phones, smart watches and other electronic devices are not allowed in the hall.",

  "Use of unfair means will lead to cancellation of the paper.",

  "Keep this admit card safe until the results are declared.",
].join("\n");

// Load saved notice settings (per browser)

const loadNotice = () => {
  try {
    const saved = JSON.parse(localStorage.getItem(NOTICE_STORAGE_KEY));

    if (saved) return saved;
  } catch (e) {
    // ignore corrupt data
  }

  return { show: true, title: DEFAULT_NOTICE_TITLE, text: "" };
};

/* =========================================================

   PRINT CSS

   Injected into a clean print window (same approach as the

   marksheet "Print V2"), so the app theme / layout wrappers

   can never hide or clip the cards.

========================================================= */

const ADMIT_PRINT_CSS = `

  @page { size: A4 portrait; margin: 8mm; }



  * { box-sizing: border-box; }



  html, body {

    margin: 0;

    padding: 0;

    background: #fff;

    -webkit-print-color-adjust: exact;

    print-color-adjust: exact;

  }



  .admit-card-list { display: block; }



  .admit-card,

  .admit-card * { color: #000 !important; }



  .admit-card {

    width: 100%;

    margin: 0;

    padding: 4mm 5mm;

    border: 0 !important;

    border-radius: 0 !important;

    box-shadow: none !important;

    background: transparent !important;

    display: block !important;

    font-size: 11px;

    line-height: 1.4;

    break-inside: avoid;

    page-break-inside: avoid;

  }



  /* 1 card per page */

  .admit-card--single {

    min-height: 265mm;

    break-after: page;

    page-break-after: always;

  }

  .admit-card--single:last-child {

    break-after: auto;

    page-break-after: auto;

  }



  /* 2 cards per page */

  .admit-card--double { margin-bottom: 4mm; }

  .admit-card--double:nth-child(2n) {

    margin-bottom: 0;

    break-after: page;

    page-break-after: always;

  }

  .admit-card--double:last-child {

    break-after: auto;

    page-break-after: auto;

  }



  /* Header */

  .admit-card-header {

    display: grid;

    grid-template-columns: 70px 1fr 70px;

    align-items: center;

    gap: 12px;

    padding: 10px 12px;

    border-radius: 8px;

    background: rgba(0, 0, 0, 0.06) !important;

  }

  .admit-card-logo { width: 62px; height: 62px; object-fit: contain; }

  .admit-card-school { text-align: center; }

  .admit-card-school-name { font-size: 19px; font-weight: 800; line-height: 1.2; }

  .admit-card-school-meta { font-size: 10.5px; font-weight: 600; margin-top: 2px; }



  /* Title */

  .admit-card-title {

    display: flex;

    flex-direction: column;

    align-items: center;

    gap: 2px;

    margin: 5mm 0 4mm;

    text-align: center;

  }

  .admit-card-title-main { font-size: 15px; font-weight: 800; letter-spacing: 0.14em; }

  .admit-card-title-test { font-size: 12.5px; font-weight: 700; }

  .admit-card-title-session { font-size: 11.5px; font-weight: 700; }



  /* Candidate */

  .admit-card-candidate {

    display: grid;

    grid-template-columns: 1fr 100px;

    gap: 12px;

    align-items: stretch;

  }

  .admit-card-info {

    display: grid;

    grid-template-columns: repeat(3, 1fr);

    gap: 10px 14px;

    padding: 10px 12px;

    border-radius: 8px;

    background: rgba(0, 0, 0, 0.06) !important;

  }

  .admit-card-info-item { display: flex; flex-direction: column; gap: 2px; min-width: 0; }

  .admit-card-info-item--full { grid-column: 1 / -1; }

  .admit-card-info-label { font-size: 9.5px; font-weight: 600; }

  .admit-card-info-value { font-size: 11.5px; font-weight: 800; overflow-wrap: anywhere; }



  .admit-card-photo {

    display: flex;

    align-items: center;

    justify-content: center;

    min-height: 120px;

    padding: 6px;

    border-radius: 8px;

    background: rgba(0, 0, 0, 0.06) !important;

    text-align: center;

    font-size: 10px;

    font-weight: 600;

  }

  .admit-card-student-photo {

    width: 100%;

    height: 100%;

    max-width: 90px;

    max-height: 108px;

    object-fit: cover;

    display: block;

  }



  /* Section title */

  .admit-card-section-title {

    font-size: 11px;

    font-weight: 800;

    letter-spacing: 0.06em;

    margin: 5mm 0 2mm;

  }



  /* Schedule table */

  .admit-card-table {

    width: 100%;

    border-collapse: collapse;

    margin: 0;

  }

  .admit-card-table th,

  .admit-card-table td {

    border: 0 !important;

    padding: 4px 6px !important;

    font-size: 11px !important;

    font-weight: 700 !important;

    text-align: center;

    vertical-align: middle;

    background: transparent !important;

  }

  .admit-card-table th:nth-child(2),
.admit-card-table td:nth-child(2) {
  text-align: left !important;
  padding-left: 10px !important;
}
.admit-card-table td.text-start { text-align: left; }

  .admit-card-table thead th {

    background: rgba(0, 0, 0, 0.13) !important;

    font-weight: 800 !important;

  }

  .admit-card-table tbody tr:nth-child(even) td {

    background: rgba(0, 0, 0, 0.06) !important;

  }



  /* Notice */

  .admit-card-notice { break-inside: avoid; }

  .admit-card-notice-body {

    padding: 8px 12px;

    border-radius: 8px;

    background: rgba(0, 0, 0, 0.06) !important;

  }

  .admit-card-notice-list {

    margin: 0;

    padding-left: 16px;

    font-size: 10.5px;

    font-weight: 600;

    line-height: 1.5;

  }



  /* Signatures */

  .admit-card-signatures {

    display: flex;

    justify-content: space-between;

    align-items: flex-end;

    gap: 24px;

    margin-top: 14mm;

  }

  .admit-card-signature { flex: 1; max-width: 190px; text-align: center; }

  .admit-card-signature img {

    width: 125px;

    height: 32px;

    object-fit: contain;

    display: block;

    margin: 0 auto 2px;

  }

  .admit-card-signature-space { height: 32px; }

  .admit-card-signature-line {

    border-top: 1px solid #000 !important;

    margin-top: 4px;

    padding-top: 5px;

    font-size: 10.5px;

    font-weight: 700;

  }

  /* Compact layout for two admit cards per A4 page */
  .admit-card--double {
    box-sizing: border-box;
    height: auto !important;
    min-height: 0 !important;
    max-height: none !important;
    margin: 0 0 4mm !important;
    padding: 3mm 4mm !important;
    overflow: visible !important;
    break-inside: avoid !important;
    page-break-inside: avoid !important;
  }
  .admit-card--double:nth-child(2n) {
    margin-bottom: 0 !important;
    break-after: page !important;
    page-break-after: always !important;
  }
  .admit-card--double:last-child {
    margin-bottom: 0 !important;
    break-after: auto !important;
    page-break-after: auto !important;
  }

  .admit-card--compact .admit-card-header {
    grid-template-columns: 42px 1fr 42px !important;
    gap: 6px !important;
    padding: 2mm 2.5mm !important;
  }
  .admit-card--compact .admit-card-logo {
    width: 38px !important;
    height: 38px !important;
  }
  .admit-card--compact .admit-card-school-name { font-size: 13px !important; }
  .admit-card--compact .admit-card-school-meta {
    font-size: 7px !important;
    margin-top: 1px !important;
  }
  .admit-card--compact .admit-card-title {
    margin: 2mm 0 1.5mm !important;
    gap: 1px !important;
  }
  .admit-card--compact .admit-card-title-main { font-size: 10px !important; }
  .admit-card--compact .admit-card-title-test { font-size: 8px !important; }
  .admit-card--compact .admit-card-title-session { font-size: 7.5px !important; }
  .admit-card--compact .admit-card-candidate {
    grid-template-columns: 1fr 55px !important;
    gap: 5px !important;
  }
  .admit-card--compact .admit-card-info {
    gap: 4px 6px !important;
    padding: 5px 7px !important;
  }
  .admit-card--compact .admit-card-info-label { font-size: 6.5px !important; }
  .admit-card--compact .admit-card-info-value {
    font-size: 7.5px !important;
    line-height: 1.15 !important;
  }
  .admit-card--compact .admit-card-photo {
    min-height: 60px !important;
    padding: 3px !important;
    font-size: 6px !important;
  }
  .admit-card--compact .admit-card-student-photo {
    max-width: 48px !important;
    max-height: 56px !important;
  }
  .admit-card--compact .admit-card-section-title {
    font-size: 7.5px !important;
    margin: 2mm 0 1mm !important;
  }
  .admit-card--compact .admit-card-table th,
  .admit-card--compact .admit-card-table td {
    padding: 2px 3px !important;
    font-size: 7.5px !important;
    line-height: 1.1 !important;
  }
  .admit-card--compact .admit-card-notice-body { padding: 4px 6px !important; }
  .admit-card--compact .admit-card-notice-list {
    padding-left: 11px !important;
    font-size: 6.5px !important;
    line-height: 1.15 !important;
  }
  .admit-card--compact .admit-card-signatures {
    margin-top: 3mm !important;
    gap: 6px !important;
  }
  .admit-card--compact .admit-card-signature img {
    width: 60px !important;
    height: 16px !important;
  }
  .admit-card--compact .admit-card-signature-space { height: 16px !important; }
  .admit-card--compact .admit-card-signature-line {
    margin-top: 2px !important;
    padding-top: 2px !important;
    font-size: 6.5px !important;
  }
/* =========================================================
   CLASSIC (BORDERED) DESIGN
========================================================= */
.admit-card.admit-card--classic {
  border: 1.5px solid currentColor !important;
  border-radius: 0 !important;
}

.admit-card.admit-card--classic .admit-card-header {
  background: transparent !important;
  border-radius: 0;
  border-bottom: 2px solid currentColor;
}

.admit-card.admit-card--classic .admit-card-title-main {
  padding: 3px 14px;
  border: 1.5px solid currentColor;
}

/* Candidate details: ruled grid */
.admit-card.admit-card--classic .admit-card-info {
  background: transparent !important;
  border-radius: 0;
  padding: 0 !important;
  gap: 0 !important;
  border-top: 1px solid currentColor;
  border-left: 1px solid currentColor;
}

.admit-card.admit-card--classic .admit-card-info-item {
  padding: 5px 8px;
  border-right: 1px solid currentColor;
  border-bottom: 1px solid currentColor;
}

.admit-card.admit-card--classic.admit-card--compact .admit-card-info-item {
  padding: 3px 5px;
}

.admit-card.admit-card--classic .admit-card-photo {
  background: transparent !important;
  border-radius: 0;
  border: 1px solid currentColor;
}

.admit-card.admit-card--classic .admit-card-student-photo {
  border-radius: 0;
}

.admit-card.admit-card--classic .admit-card-section-title {
  text-transform: uppercase;
}

/* Schedule: full gridlines */
.admit-card.admit-card--classic .admit-card-table {
  border-collapse: collapse;
  border-radius: 0;
  overflow: visible;
}

.admit-card.admit-card--classic .admit-card-table th,
.admit-card.admit-card--classic .admit-card-table td {
  border: 1px solid currentColor !important;
}

.admit-card.admit-card--classic .admit-card-table thead th {
  background: color-mix(in srgb, currentColor 10%, transparent) !important;
}

.admit-card.admit-card--classic .admit-card-table tbody tr:nth-child(even) td {
  background: transparent !important;
}

/* Notice */
.admit-card.admit-card--classic .admit-card-notice-body {
  background: transparent !important;
  border: 1px solid currentColor;
  border-radius: 0;
}
`;

// Wait for images + stylesheets in the print window before calling print()

const waitForPrintWindowAssets = (win) => {
  const images = Array.from(win.document.images || []).map(
    (img) =>
      new Promise((resolve) => {
        if (img.complete) return resolve();

        img.addEventListener("load", resolve, { once: true });

        img.addEventListener("error", resolve, { once: true });
      }),
  );

  const sheets = Array.from(
    win.document.querySelectorAll('link[rel="stylesheet"]'),
  ).map(
    (link) =>
      new Promise((resolve) => {
        if (link.sheet) return resolve();

        link.addEventListener("load", resolve, { once: true });

        link.addEventListener("error", resolve, { once: true });
      }),
  );

  return Promise.all([...images, ...sheets]);
};

export default function AdmitCard() {
  const hasAccess = usePrivateLink();

  const instituteData = JSON.parse(localStorage.getItem("setting")) || {};

  const [studentSel, setStudentSel] = useState([]);

  const [showCards, setShowCards] = useState(false);

  const cardRef = useRef();

  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);

  const details = queryParams.get("details");

  const [selectedBatch, setSelectedBatch] = useState("");

  const [batchStudents, setBatchStudents] = useState([]);

  const [batch, setBatch] = useState();

  const [page, setPage] = useState(1);

  const [search, setSearch] = useState("");

  const [List, setList] = useState([]);

  const [testListData, setTestListData] = useState("");

  const [parent, setParent] = useState("");

  const [subjectDetails, setSubjectDetails] = useState([]);

  const [print, setPrint] = useState("");

  const [loading, setLoading] = useState(false);

  const [error, setError] = useState("");

  const [sessions, setSessions] = useState([]);

  const [selectedSession, setSelectedSessions] = useState("");

  const [type, setType] = useState("card");

  const [schedule, setSchedule] = useState([]);

  const [detail, setDetail] = useState([]);

  // Notice / terms & conditions

  const [notice, setNotice] = useState(loadNotice);

  const [cardsPerPage, setCardsPerPage] = useState(2);

  const [design, setDesign] = useState(loadDesign);

  useEffect(() => {
    try {
      localStorage.setItem(DESIGN_STORAGE_KEY, design);
    } catch (e) {
      // not critical
    }
  }, [design]);

  // Save notice whenever it changes

  useEffect(() => {
    try {
      localStorage.setItem(NOTICE_STORAGE_KEY, JSON.stringify(notice));
    } catch (e) {
      // storage full / blocked - not critical
    }
  }, [notice]);

  // One point per line -> list items

  const noticeLines = useMemo(
    () =>
      (notice.text || "")

        .split("\n")

        .map((line) => line.replace(/^\s*(\d+[.)]|[-•*])\s*/, "").trim())

        .filter(Boolean),

    [notice.text],
  );

  useEffect(() => {
    if (selectedSession) {
      fetchBatches();
    }
  }, [selectedSession]);

  useEffect(() => {
    if (testListData) {
      fetchStudents();
    }
  }, [testListData]);

  const getSession = async () => {
    setLoading(true);

    try {
      const response = await getSessions();

      if (response?.data?.status) {
        const activeSession = response?.data?.data.find(
          (session) => session.status === "1",
        );

        setSelectedSessions(activeSession?.id ?? "");

        setSessions(response?.data?.data);
      } else {
        setError("Failed to fetch session?.");
      }
    } catch (err) {
      setError(err?.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getSession();
  }, []);

  const fetchBatches = async () => {
    const addUrl = `&session_id=${selectedSession}`;

    setLoading(true);

    try {
      const response = await viewlist(addUrl);

      if (response?.data?.status) {
        setBatch(response.data);
      } else {
        alert("Failed to fetch batches");
      }
    } catch (err) {
      console.error(err);

      alert("Error fetching batches");
    } finally {
      setLoading(false);
    }
  };

  const fetchStudents = async () => {
    setLoading(true);

    let addUrl = `&test_id=${testListData}&batch_id=${selectedBatch}`;

    try {
      const res = await fetchCard(addUrl);

      if (res?.data?.status) {
        setBatchStudents(res.data?.data?.marks);

        setSubjectDetails(res.data?.data?.subject_details || []);

        let scheduleData = [];

        if (res?.data?.data?.subject_schedule) {
          try {
            scheduleData = JSON.parse(res.data?.data?.subject_schedule);
          } catch (e) {
            console.error("Failed to parse subject_schedule", e);
          }
        }

        setSchedule(scheduleData);

        setDetail(res?.data?.data);
      } else {
        alert("No students found for selected batch");
      }
    } catch (err) {
      console.error(err);

      alert("Failed to load students");
    } finally {
      setLoading(false);
    }
  };

  const fetchList = async () => {
    setLoading(true);

    let addUrl = `&page=${page}&batch_id=${selectedBatch}&search=${search}`;

    try {
      const response = await testList(addUrl);

      if (response.data.status) {
        setList(response?.data?.data);
      }
    } catch (error) {
      SweetAlertShow(
        "error",

        "Error",

        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedBatch) {
      fetchList();
    }
  }, [search, selectedBatch, parent]);

  const handleSubmit = () => {
    if (batch && List && batchStudents.length && studentSel) {
      setShowCards(true);

      setTimeout(() => {
        cardRef.current?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    } else alert("Please select all fields!");
  };

  // Print in a clean window (same approach as marksheet "Print V2")

  const handlePrint = async () => {
    const element = document.getElementById("AdmitPrintDiv");

    if (!element) return;

    const printWindow = window.open("", "\_blank");

    if (!printWindow) {
      alert("Popup blocked! Please allow popups.");

      return;
    }

    printWindow.document.write(`

      <!DOCTYPE html>

      <html>

        <head>

          <base href="${window.location.origin}/" />

          <title>Admit Cards</title>

          <link href="https\://cdn.jsdelivr.net/npm/bootstrap\@5.3.3/dist/css/bootstrap.min.css" rel="stylesheet">

          <style>${ADMIT_PRINT_CSS}</style>

        </head>

        <body>

          ${element.outerHTML}

        </body>

      </html>

    `);

    printWindow.document.close();

    await waitForPrintWindowAssets(printWindow);

    setTimeout(() => {
      printWindow.focus();

      printWindow.print();

      printWindow.close();
    }, 300);
  };

  const sortedSchedule = useMemo(
    () =>
      [...(schedule || [])].sort((a, b) => new Date(a.date) - new Date(b.date)),

    [schedule],
  );

  const selectedStudents = batchStudents?.filter((student) =>
    studentSel.includes("All")
      ? true
      : studentSel.includes(String(student?.student_details?.id)),
  );

  const instituteAddress = [
    instituteData?.village,

    instituteData?.district,

    instituteData?.state,
  ]

    .filter(Boolean)

    .join(", ");

  const showNoticeOnCard = notice.show && noticeLines.length > 0;

  const sessionName = sessions?.find(
    (item) => String(item?.id) === String(selectedSession),
  )?.session;

  return (
    <>
      {loading && <LoadingDiv />}

      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />

          <div className="layout-page">
            <Nav />

            <div className="content-wrapper">
              <div className="container-fluid">
                <div className="row">
                  <TestLayout />

                  <div className="col-12">
                    <div className="no-print">
                      <div className="card shadow-sm border-0 mb-4 admit-generator-card">
                        {/* Header */}

                        <div className="card-header bg-transparent border-bottom px-4 py-3">
                          <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
                            <div className="d-flex align-items-center">
                              <div
                                className="bg-label-primary rounded-3 d-flex align-items-center justify-content-center me-3"
                                style={{
                                  width: 48,

                                  height: 48,

                                  minWidth: 48,
                                }}
                              >
                                <i className="ri-file-chart-line fs-3 text-primary"></i>
                              </div>

                              <div>
                                <h4 className="fw-bold mb-1">
                                  Admit Card Generator
                                </h4>

                                <p className="text-muted mb-0">
                                  Select examination details to generate admit
                                  cards.
                                </p>
                              </div>
                            </div>

                            <div className="d-flex align-items-center gap-2">
                              <span className="badge rounded-pill bg-primary px-3 py-2">
                                <i className="ri-group-line me-1"></i>
                                {batchStudents.length} Students
                              </span>
                            </div>
                          </div>
                        </div>

                        {/* Selection Area */}

                        <div className="card-body p-4">
                          <div className="row g-3">
                            {/* Session */}

                            <div className="col-xl-3 col-lg-4 col-md-6">
                              <div className="form-floating form-floating-outline">
                                <select
                                  className="form-select"
                                  name="session"
                                  value={selectedSession}
                                  onChange={(e) =>
                                    setSelectedSessions(e.target.value)
                                  }
                                >
                                  {sessions?.map((session) => (
                                    <option
                                      key={session?.id}
                                      value={session?.id}
                                    >
                                      {session?.session}

                                      {session?.status == "1"
                                        ? " - Active"
                                        : " - Inactive"}
                                    </option>
                                  ))}
                                </select>

                                <label>
                                  <i className="ri-calendar-line me-1"></i>
                                  Session
                                </label>
                              </div>
                            </div>

                            {/* Batch */}

                            <div className="col-xl-3 col-lg-4 col-md-6">
                              <div className="form-floating form-floating-outline">
                                <select
                                  name="batch_id"
                                  className="form-select"
                                  value={selectedBatch}
                                  onChange={(e) =>
                                    setSelectedBatch(e.target.value)
                                  }
                                >
                                  <option value="">All Batch</option>

                                  {batch?.data?.map((batchItem, i) => {
                                    const courseTitle =
                                      batchItem?.course?.title || "";

                                    const shortCourseTitle =
                                      courseTitle.length > 20
                                        ? courseTitle.substring(0, 20) + "..."
                                        : courseTitle;

                                    return (
                                      <option key={i} value={batchItem?.id}>
                                        {`${batchItem?.title} (${shortCourseTitle})`}
                                      </option>
                                    );
                                  })}
                                </select>

                                <label>
                                  <i className="ri-group-line me-1"></i>
                                  Batch
                                </label>
                              </div>
                            </div>

                            {/* Test */}

                            <div className="col-xl-3 col-lg-4 col-md-6">
                              <div className="form-floating form-floating-outline">
                                <select
                                  className="form-select"
                                  value={testListData}
                                  onChange={(e) =>
                                    setTestListData(e.target.value)
                                  }
                                >
                                  <option value="">Select Test</option>

                                  {List?.data?.map((t) => (
                                    <option key={t.id} value={t.id}>
                                      {t.title}
                                    </option>
                                  ))}
                                </select>

                                <label>
                                  <i className="ri-file-list-3-line me-1"></i>
                                  Test
                                </label>
                              </div>
                            </div>

                            {/* Student Selection */}

                            {testListData && (
                              <div className="col-xl-3 col-lg-12 col-md-6">
                                <div className="form-floating form-floating-outline">
                                  <select
                                    className="form-select"
                                    multiple
                                    value={studentSel}
                                    onChange={(e) => {
                                      const opts = Array.from(
                                        e.target.selectedOptions,

                                        (o) => o.value,
                                      );

                                      setStudentSel(opts);
                                      setPrint("1");
                                    }}
                                    style={{
                                      minHeight: "58px",
                                      height: "58px",
                                      paddingTop: "20px",
                                    }}
                                  >
                                    <option value="All">All Students</option>

                                    {batchStudents?.map((s) => (
                                      <option
                                        key={s.student_details.id}
                                        value={s.student_details.id}
                                      >
                                        {s.student_details.name}
                                      </option>
                                    ))}
                                  </select>

                                  <label>
                                    <i className="ri-user-line me-1"></i>
                                    Students
                                  </label>
                                </div>

                                <small className="text-muted d-block mt-1">
                                  Hold Ctrl/Cmd to select multiple students
                                </small>
                              </div>
                            )}
                          </div>

                          {testListData && (
                            <>
                              {/* Notice / Terms editor */}
                              <div className="border-top mt-4 pt-4 admit-notice-editor">
                                <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
                                  <div>
                                    <h6 className="fw-bold mb-1">
                                      Notice / Terms &amp; Conditions
                                    </h6>
                                    <small className="text-muted">
                                      Printed at the end of every admit card.
                                      Write one point per line. Saved on this
                                      browser.
                                    </small>
                                  </div>

                                  <div className="form-check form-switch mb-0">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      role="switch"
                                      id="admitNoticeSwitch"
                                      checked={notice.show}
                                      onChange={(e) =>
                                        setNotice({
                                          ...notice,
                                          show: e.target.checked,
                                        })
                                      }
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="admitNoticeSwitch"
                                    >
                                      Show on admit card
                                    </label>
                                  </div>
                                </div>

                                {notice.show && (
                                  <div className="row g-3">
                                    <div className="col-lg-4">
                                      <div className="form-floating form-floating-outline">
                                        <input
                                          type="text"
                                          className="form-control"
                                          id="admitNoticeTitle"
                                          placeholder="Heading"
                                          value={notice.title}
                                          onChange={(e) =>
                                            setNotice({
                                              ...notice,
                                              title: e.target.value,
                                            })
                                          }
                                        />
                                        <label htmlFor="admitNoticeTitle">
                                          Heading
                                        </label>
                                      </div>

                                      <div className="d-flex flex-wrap gap-2 mt-3">
                                        <button
                                          type="button"
                                          className="btn btn-sm btn-outline-primary"
                                          onClick={() =>
                                            setNotice({
                                              ...notice,
                                              title: DEFAULT_NOTICE_TITLE,
                                              text: DEFAULT_NOTICE_TEXT,
                                            })
                                          }
                                        >
                                          Use default instructions
                                        </button>
                                        <button
                                          type="button"
                                          className="btn btn-sm btn-outline-secondary"
                                          onClick={() =>
                                            setNotice({ ...notice, text: "" })
                                          }
                                          disabled={!notice.text}
                                        >
                                          Clear
                                        </button>
                                      </div>

                                      {/* <div className="mt-3">
                                        <label
                                          className="form-label mb-1"
                                          htmlFor="admitCardsPerPage"
                                        >
                                          Cards per printed page
                                        </label>
                                        <select
                                          id="admitCardsPerPage"
                                          className="form-select"
                                          value={cardsPerPage}
                                          onChange={(e) =>
                                            setCardsPerPage(
                                              Number(e.target.value),
                                            )
                                          }
                                        >
                                          <option value={1}>
                                            1 (recommended with notice)
                                          </option>
                                          <option value={2}>2 (compact)</option>
                                        </select>
                                      </div> */}
                                    </div>

                                    <div className="col-lg-8">
                                      <div className="form-floating form-floating-outline">
                                        <textarea
                                          className="form-control h-auto"
                                          id="admitNoticeText"
                                          rows={6}
                                          placeholder="Notice"
                                          value={notice.text}
                                          onChange={(e) =>
                                            setNotice({
                                              ...notice,
                                              text: e.target.value,
                                            })
                                          }
                                        />
                                        <label htmlFor="admitNoticeText">
                                          Notice / terms (one point per line)
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>

                              {/* Actions */}
                              <div className="border-top mt-4 pt-4">
                                <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
                                  {/* Left information */}
                                  <div className="d-flex align-items-center">
                                    <div
                                      className="bg-label-primary rounded-3 d-flex align-items-center justify-content-center me-3"
                                      style={{
                                        width: 42,
                                        height: 42,
                                        minWidth: 42,
                                      }}
                                    >
                                      <i className="ri-file-list-3-line fs-4 text-primary"></i>
                                    </div>

                                    <div>
                                      <h6 className="fw-bold mb-1">
                                        Admit Card Generation
                                      </h6>

                                      <small className="text-muted">
                                        {studentSel.includes("All")
                                          ? `All ${batchStudents.length} students selected`
                                          : studentSel.length > 0
                                            ? `${studentSel.length} student${studentSel.length > 1 ? "s" : ""
                                            } selected`
                                            : "Select one or more students to continue"}
                                      </small>
                                    </div>
                                  </div>

                                  {/* Buttons */}
                                  <div className="d-flex align-items-center gap-2 flex-wrap">
                                    <div
                                      className="form-floating form-floating-outline"
                                      style={{ minWidth: 220 }}
                                    >
                                      <select
                                        id="admitDesign"
                                        className="form-select"
                                        value={design}
                                        onChange={(e) =>
                                          setDesign(e.target.value)
                                        }
                                      >
                                        {ADMIT_DESIGNS.map((d) => (
                                          <option key={d.value} value={d.value}>
                                            {d.label}
                                          </option>
                                        ))}
                                      </select>
                                      <label htmlFor="admitDesign">
                                        <i className="ri-layout-line me-1"></i>
                                        Admit Card Design
                                      </label>
                                    </div>
                                    <button
                                      type="button"
                                      className="btn btn-primary px-4"
                                      onClick={handleSubmit}
                                      disabled={
                                        !testListData ||
                                        batchStudents.length === 0 ||
                                        studentSel.length === 0
                                      }
                                    >
                                      <i className="ri-file-list-3-line me-2"></i>
                                      Generate Admit Cards
                                    </button>

                                    {/* {hasAccess("/admit/card/print") && ( */}
                                    {hasAccess("/tests/report/print") && (
                                      <button
                                        type="button"
                                        className="btn btn-outline-primary px-4"
                                        onClick={handlePrint}
                                        disabled={!showCards}
                                      >
                                        <i className="ri-printer-line me-2"></i>
                                        Print Admit Cards
                                      </button>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>

                    {type === "card" && showCards && (
                      <div
                        ref={cardRef}
                        id="AdmitPrintDiv"
                        className="print-area admit-card-list"
                      >
                        {selectedStudents.map((student, idx) => {
                          const sd = student?.student_details;

                          return (
                            <div
                              key={sd?.id ?? idx}
                              className={`admit-card card admit-card--${design} ${cardsPerPage === 2
                                ? "admit-card--double admit-card--compact"
                                : "admit-card--single"
                                }`}
                            >
                              {/* ---------- Header ---------- */}
                              <div className="admit-card-header">
                                <img
                                  src={
                                    instituteData?.logo_img
                                      ? `${imgBaseUrl}${instituteData.logo_img}`
                                      : "/files/logo.png"
                                  }
                                  alt="School Logo"
                                  className="admit-card-logo"
                                />

                                <div className="admit-card-school">
                                  <div className="admit-card-school-name">
                                    {instituteData?.name || "School Name"}
                                  </div>

                                  {instituteAddress && (
                                    <div className="admit-card-school-meta">
                                      {instituteAddress}
                                    </div>
                                  )}

                                  <div className="admit-card-school-meta">
                                    {instituteData?.mobile && (
                                      <>
                                        <strong>Mobile:</strong>{" "}
                                        {instituteData.mobile}
                                      </>
                                    )}
                                    {instituteData?.secondary_mobile && (
                                      <>
                                        {" | "}
                                        {instituteData.secondary_mobile}
                                      </>
                                    )}
                                    {instituteData?.email && (
                                      <>
                                        {" | "}
                                        <strong>Email:</strong>{" "}
                                        {instituteData.email}
                                      </>
                                    )}
                                  </div>
                                </div>

                                {/* keeps the school name visually centered */}
                                <div className="admit-card-header-spacer"></div>
                              </div>

                              {/* ---------- Title ---------- */}
                              <div className="admit-card-title">
                                <span className="admit-card-title-main">
                                  EXAMINATION ADMIT CARD
                                </span>
                                {(detail?.title || detail?.test?.title) && (
                                  <span className="admit-card-title-test">
                                    {detail?.title || detail?.test?.title}
                                  </span>
                                )}
                                {sessionName && (
                                  <span className="admit-card-title-session">
                                    Academic Session: {sessionName}
                                  </span>
                                )}
                              </div>

                              {/* ---------- Candidate details ---------- */}
                              <div className="admit-card-candidate">
                                <div className="admit-card-info">
                                  <div className="admit-card-info-item">
                                    <span className="admit-card-info-label">
                                      Student Name
                                    </span>
                                    <span className="admit-card-info-value">
                                      {sd?.name || "-"}
                                    </span>
                                  </div>

                                  <div className="admit-card-info-item">
                                    <span className="admit-card-info-label">
                                      Father's Name
                                    </span>
                                    <span className="admit-card-info-value">
                                      {sd?.father_name || "-"}
                                    </span>
                                  </div>

                                  <div className="admit-card-info-item">
                                    <span className="admit-card-info-label">
                                      Registration No.
                                    </span>
                                    <span className="admit-card-info-value">
                                      {sd?.registration_no || "-"}
                                    </span>
                                  </div>

                                  <div className="admit-card-info-item">
                                    <span className="admit-card-info-label">
                                      Roll No.
                                    </span>
                                    <span className="admit-card-info-value">
                                      {sd?.course_and_fees?.[0]?.roll_number ||
                                        "-"}
                                    </span>
                                  </div>

                                  <div className="admit-card-info-item">
                                    <span className="admit-card-info-label">
                                      Class / Batch
                                    </span>
                                    <span className="admit-card-info-value">
                                      {detail?.batches?.course?.title || "-"}
                                      {detail?.batches?.title
                                        ? ` (${detail.batches.title})`
                                        : ""}
                                    </span>
                                  </div>

                                  <div className="admit-card-info-item">
                                    <span className="admit-card-info-label">
                                      Mobile
                                    </span>
                                    <span className="admit-card-info-value">
                                      {sd?.phone || "-"}
                                    </span>
                                  </div>

                                  <div className="admit-card-info-item admit-card-info-item--full">
                                    <span className="admit-card-info-label">
                                      Address
                                    </span>
                                    <span className="admit-card-info-value">
                                      {[
                                        sd?.village,
                                        sd?.district,
                                        sd?.state,
                                        sd?.zipcode,
                                      ]
                                        .filter(Boolean)
                                        .join(", ") || "-"}
                                    </span>
                                  </div>
                                </div>

                                <div className="admit-card-photo">
                                  {sd?.profile_picture ? (
                                    <img
                                      src={`${imgBaseUrl}${sd.profile_picture}`}
                                      alt={`${sd?.name || "Student"} Profile`}
                                      className="admit-card-student-photo"
                                    />
                                  ) : (
                                    "Affix passport size photograph"
                                  )}
                                </div>
                              </div>

                              {/* ---------- Schedule ---------- */}
                              <div className="admit-card-section-title">
                                Examination Schedule
                              </div>

                              <table className="admit-card-table">
                                <thead>
                                  <tr>
                                    <th style={{ width: "8%" }}>S.No.</th>
                                    <th>Subject</th>
                                    <th style={{ width: "25%" }}>Date</th>
                                    <th style={{ width: "22%" }}>Day</th>
                                  </tr>
                                </thead>

                                <tbody>
                                  {sortedSchedule.length > 0 ? (
                                    sortedSchedule.map((sub, i) => (
                                      <tr key={i}>
                                        <td>{i + 1}</td>
                                        <td className="text-start">
                                          {sub?.subject_name || "-"}
                                        </td>
                                        <td>
                                          {sub?.date
                                            ? moment(sub.date).format(
                                              "DD MMM YYYY",
                                            )
                                            : "-"}
                                        </td>
                                        <td>
                                          {sub?.date
                                            ? moment(sub.date).format("dddd")
                                            : "-"}
                                        </td>
                                      </tr>
                                    ))
                                  ) : (
                                    <tr>
                                      <td colSpan="4">No schedule found</td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>

                              {/* ---------- Notice / Terms ---------- */}
                              {showNoticeOnCard && (
                                <div className="admit-card-notice">
                                  <div className="admit-card-section-title">
                                    {notice.title || DEFAULT_NOTICE_TITLE}
                                  </div>

                                  <div className="admit-card-notice-body">
                                    <ol className="admit-card-notice-list">
                                      {noticeLines.map((line, i) => (
                                        <li key={i}>{line}</li>
                                      ))}
                                    </ol>
                                  </div>
                                </div>
                              )}

                              {/* ---------- Signatures ---------- */}
                              <div className="admit-card-signatures">
                                <div className="admit-card-signature">
                                  <div className="admit-card-signature-space"></div>
                                  <div className="admit-card-signature-line">
                                    Candidate Signature
                                  </div>
                                </div>

                                <div className="admit-card-signature">
                                  <div className="admit-card-signature-space"></div>
                                  <div className="admit-card-signature-line">
                                    Class Teacher
                                  </div>
                                </div>

                                <div className="admit-card-signature">
                                  {instituteData?.signature ? (
                                    <img
                                      src={`${imgBaseUrl}${instituteData.signature}`}
                                      alt="Principal Signature"
                                    />
                                  ) : (
                                    <div className="admit-card-signature-space"></div>
                                  )}
                                  <div className="admit-card-signature-line">
                                    Principal Signature
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                  <div className="no-print">
                    <Footer />
                  </div>
                </div>
              </div>
              <div className="content-backdrop fade"></div>
            </div>
          </div>
          <div className="layout-overlay layout-menu-toggle"></div>
          <div className="drag-target"></div>
        </div>
      </div>
    </>
  );
}
